import React from 'react';

/**
 * Three-dot animated typing indicator shown while the assistant is streaming
 * a response. Styled via a keyframe animation declared elsewhere.
 */
export function TypingIndicator(): React.JSX.Element {
  return (
    <div style={{ display: 'flex', gap: '4px', padding: '8px 16px' }}>
      <Dot delay={0} />
      <Dot delay={150} />
      <Dot delay={300} />
    </div>
  );
}

/** One pulsing dot for the typing indicator. */
function Dot({ delay }: { delay: number }): React.JSX.Element {
  return (
    <span
      style={{
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        backgroundColor: '#01A9ED',
        display: 'inline-block',
        animation: `dotPulse 1.2s ${delay}ms infinite ease-in-out`,
        opacity: 0.4,
      }}
    />
  );
}
